
import { Vue } from "vue-class-component";
export default class AccountManage extends Vue {}
